export default __webpack_public_path__ + "static/media/vegetablechips@3x.b3a15ed1.jpg";